import { ExternalLinkIcon } from 'lucide-react';
import type React from 'react';
import { forwardRef } from 'react';

const ExternalLink = forwardRef<HTMLAnchorElement, Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'target' | 'rel'>>(({ children, ...props }, ref) => {
  return (
    <a ref={ref} {...props} target="_blank" rel="external noopener noreferrer">
      {children}
      <ExternalLinkIcon className="size-4 inline align-text-bottom ml-1" />
    </a>
  );
});

ExternalLink.displayName = 'ExternalLink';

export default ExternalLink;
